import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Faq.css';

const faqData = [
  {
    id: 1,
    question: "What types of insulation materials do you provide?",
    answer: "We provide a comprehensive range of high-performance materials including XLPE, Nitrile Rubber, Boiler insulation, and specialized Acoustic insulation materials tailored for industrial needs."
  },
  {
    id: 2,
    question: "Do you provide installation services along with material supply?",
    answer: "Yes, we are a full-service provider. We not only supply high-quality materials but also offer expert installation services for industrial projects and ducting solutions."
  },
  {
    id: 3,
    question: "Which industries do you serve?",
    answer: "We serve a wide variety of sectors including HVAC, manufacturing, pharmaceuticals, power plants, and large-scale commercial infrastructure projects."
  },
  {
    id: 4,
    question: "What are the benefits of nitrile rubber insulation?",
    answer: "Nitrile rubber offers excellent thermal resistance, moisture protection, and flexibility, making it ideal for condensation control in chilled water and refrigeration piping."
  },
  {
    id: 5,
    question: "Do you offer customized insulation solutions?",
    answer: "Absolutely. We understand that every industrial site has unique requirements. Our team provides technical consultations to design and implement customized insulation strategies."
  },
  {
    id: 6,
    question: "How do you ensure quality in your services?",
    answer: "With over 9 years of expertise, we adhere to strict international standards, using only premium materials and employing highly trained professionals for every project."
  },
  {
    id: 7,
    question: "Do you handle large-scale industrial projects?",
    answer: "Yes, we specialize in large-scale industrial projects, providing both the manpower and the material volume necessary for extensive ducting and thermal control systems."
  },
  {
    id: 8,
    question: "How can I request a quote or consultation?",
    answer: "You can reach out via our 'Contact Us' page or click the 'Get Quote' button on our homepage. Our team typically responds within 24 hours to schedule a detailed technical discussion."
  }
];

const FAQ = () => {
  const [activeId, setActiveId] = useState(null);

  const toggleFAQ = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <h2 className="faq-main-title">FAQ's</h2>
        
        <div className="faq-grid">
          {faqData.map((faq) => (
            <div 
              key={faq.id} 
              className={`faq-item ${activeId === faq.id ? 'active' : ''}`}
              onClick={() => toggleFAQ(faq.id)}
            >
              <div className="faq-question-row">
                <span className="faq-icon">{activeId === faq.id ? '−' : '+'}</span>
                <p className="faq-question-text">{faq.question}</p>
              </div>

              <AnimatePresence>
                {activeId === faq.id && (
                  <motion.div 
                    className="faq-answer-wrapper"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                  >
                    <div className="faq-answer-content">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;